import { render, staticRenderFns } from "./HeaderTheme.vue?vue&type=template&id=87fc9c6a"
import script from "./HeaderTheme.vue?vue&type=script&lang=js"
export * from "./HeaderTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports